<script setup>
import benefits from '@/config/benefits';

const { t } = useI18n();
</script>

<template>
  <div class="banners-why">
    <CImage
      class="banners-why__background"
      src="/images/main/banner-bg.png"
      alt="background"
      loading="lazy"
    />

    <div class="banners-why__container">
      <div class="banners-why__title">
        <span class="banners-why__font banners-why__font--title">
          {{ t('banners.why.title') }}
        </span>
      </div>

      <div class="banners-why__benefits">
        <div
          v-for="(benefit, index) in benefits"
          :key="index"
          class="banners-why__benefit"
        >
          <div class="banners-why__wrapper banners-why__wrapper--icon">
            <CIcon class="banners-why__icon" :name="benefit.iconName" />
          </div>

          <span class="banners-why__font banners-why__font--benefit">
            {{ t(benefit.title) }}
          </span>
        </div>
      </div>

      <div class="banners-why__wrapper banners-why__wrapper--app">
        <div class="banners-why__buttons">
          <span
            class="banners-why__font banners-why__font--download"
            v-html="t('banners.why.downloadApp')"
          />

          <BundlesAppButtons class="banners-why__stores" size="md" />
        </div>

        <CImage
          class="banners-why__image"
          src="/images/main/qr.png"
          title="Qr code"
          alt="Qr code"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.banners-why {
  /* Ultrawide */
  @media (aspect-ratio >= 2.29) and (aspect-ratio <= 2.66) {
    font-size: em(12);
  }

  /* Super ultrawide */
  @media (aspect-ratio >= 2.67) {
    font-size: em(10);
  }

  &__font {
    display: block;

    &--title {
      font-size: em(30);
    }

    &--benefit {
      font-size: em(17);
      line-height: math.div(19, 17);
    }

    &--download {
      font-size: em(20);
      line-height: math.div(22, 20);
    }
  }

  &__icon {
    flex-shrink: 0;
    max-width: em(40);
    max-height: em(37);
    color: $color-second-1;
  }

  &__background {
    position: absolute;
    inset: 0;
    z-index: 1;
    width: em(390);
    height: em(693);
    object-fit: contain;
  }

  &__container {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    width: em(390);
    height: em(693);
    padding: em(33) em(27) em(30);
    color: $color-white;
  }

  &__title {
    margin-bottom: em(30);
  }

  &__benefits {
    display: flex;
    flex-direction: column;
    gap: em(17);
    margin-bottom: em(20);
  }

  &__benefit {
    display: flex;
    gap: em(17);
    align-items: center;
  }

  &__wrapper {
    &--icon {
      @include box(em(62));

      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      background-color: $color-main-28;
      border-radius: em(15);
    }

    &--app {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: auto;
    }
  }

  &__stores {
    margin-top: em(25);
  }

  &__image {
    @include box(em(126));

    flex-shrink: 0;
    object-fit: contain;
  }
}
</style>
